export default __webpack_public_path__ + "static/media/about.9ccb607c.png";